module.exports = __webpack_public_path__ + "media/images/set-restrictions-1d5d8afa8b2b317cdadae48f05a22557.svg";